<template>
  <div class="edm-unsubscribe-container">
    <div class="unsubscribe-text">{{ $t('apply_unsubscribe_title') }}?</div>
    <el-button size="small" type="primary" class="unsubscribe-btn" @click="handleUnsubscibe">{{
      $t('apply_unsubscribe_confirm')
    }}</el-button>
  </div>
</template>
<style lang="scss" scoped>
  .edm-unsubscribe-container {
    width: 960px;
    padding-top: 100px;
    margin: 0 auto;
    text-align: center;
    .unsubscribe-text {
      margin-top: 60px;
      font-size: 18px;
      line-height: 18px;
      color: var(--gray-33);
    }
    .unsubscribe-btn {
      margin-top: 30px;
      width: 100px;
    }
    @media (max-width: 960px) {
      width: 100%;
    }
  }
</style>
<script>
  import { edm_unsubscribe } from '@/services/edm'
  export default {
    data() {
      return {}
    },
    mounted() {},
    methods: {
      async handleUnsubscibe() {
        // let search = location.search;
        // if (!search || search == '?') return;
        // search = decodeURIComponent(search.substr(1));
        const query = this.$route.query
        try {
          const data = await edm_unsubscribe({
            email_id: decodeURIComponent(query.email_id),
            corp_id: decodeURIComponent(query.corp_id),
            task_id: decodeURIComponent(query.task_id),
            area: decodeURIComponent(query.area)
          })
          if (data.errno == 0) {
            this.$router.push({ path: '/edm/success' })
          } else {
            this.$message.error(this.$t('err_networkbusy'))
          }
        } catch (e) {}
      }
    }
  }
</script>
